import type { RouteRecordRaw } from "vue-router";

export const bookingsRoutes: RouteRecordRaw[] = [
  {
    path: "/coupons",
    name: "coupons",
    component: () => import(/* webpackChunkName: "dashboard-coupons" */ "../../components/coupons/CouponsView.vue"),
    meta: { titleKey: "pageTitle.coupons", viewGroup: "coupons" }
  },
  {
    path: "/bookings",
    name: "bookings",
    component: () => import(/* webpackChunkName: "dashboard-bookings" */ "../../components/bookings/BookingsView.vue"),
    meta: { titleKey: "pageTitle.bookings", viewGroup: "bookings" }
  },
  {
    path: "/receipts",
    name: "receipts",
    component: () => import(/* webpackChunkName: "dashboard-receipts" */ "../../components/receipts/ReceiptsView.vue"),
    meta: { titleKey: "pageTitle.receipts", viewGroup: "receipts" }
  }
];
